import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import NoCover from '../../../img/no-cover.svg';
// import mediaCover from '../../../img/welcome/home/media.png';
// import serviceCover from '../../../img/welcome/home/service.png';
// import tvCover from '../../../img/welcome/home/tv2.jpg';
import { translit1 } from '../../../components/common';
import { useLanguage } from '../../../hooks';
import { MediaProduct, MediaUnit, ProductUnit, TVUnit } from '../../../services/content_v1';

interface WelcomeRecommendProps {
    items: MediaProduct[],
}

function WelcomeRecommend({ items: recommendations }: WelcomeRecommendProps) {
    const lang = useLanguage()

    return recommendations.length > 0 && (
        <section className="welcome-section">
            <div className="welcome-section__back"></div>
            <div className="welcome-section__body">
                <section className="welcome-recommend">
                    <header className="welcome-header">
                        <h2 className="welcome-header__heading">
                            <a href={`/${lang}/public-showcase/media`}><Trans>We recommend</Trans><LinkTo /></a>
                        </h2>
                        <div className="welcome-header__link">
                            <a href={`/${lang}/public-showcase/media`}><Trans>See all</Trans><LinkTo /></a>
                        </div>
                    </header>
                    <div className="welcome-recommend__list">
                        {recommendations.map((unit) => <div key={unit.id} className="welcome-recommend__list-item">
                            <article className="welcome-recommend__item">
                                <div className="welcome-recommend__item-image">
                                    {unit.product.covers.length > 0 ?
                                        <img src={unit.product.covers[0]} loading="lazy" alt="" style={{ objectFit: 'contain' }} />
                                        :
                                        <img src={NoCover} alt="" />}
                                </div>
                                <div className="welcome-recommend__item-category">
                                    {unit.type === 'media' && t('Video content')}
                                    {unit.type === 'tv' && t('TV channels')}
                                    {unit.type === 'product' && t('content:SERVICES')}
                                </div>
                                <div className="welcome-recommend__item-name">
                                    {/* TODO XXX */}
                                    {unit.type === 'media' && <a href={`/${lang}/public-showcase/media/${unit.product.id}_${translit1((unit.product as MediaUnit).title) || '_'}`}>{(unit.product as MediaUnit).title}</a>}
                                    {unit.type === 'tv' && <a href={`/${lang}/public-showcase/tv/${unit.product.id}_${translit1((unit.product as TVUnit).title) || '_'}`}>{(unit.product as TVUnit).title}</a>}
                                    {unit.type === 'product' && <a href={`/${lang}/public-showcase/product/${unit.product.id}_${translit1((unit.product as ProductUnit).name) || '_'}`}>{(unit.product as ProductUnit).name}</a>}
                                </div>
                            </article>
                        </div>)}
                    </div>
                </section>
            </div>
        </section>
    );
}

export default WelcomeRecommend;